import { render, staticRenderFns } from "./Historical.vue?vue&type=template&id=636da42a&scoped=true"
import script from "./Historical.vue?vue&type=script&lang=js"
export * from "./Historical.vue?vue&type=script&lang=js"
import style0 from "./Historical.vue?vue&type=style&index=0&id=636da42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636da42a",
  null
  
)

export default component.exports